var render = function render(){var _vm=this,_c=_vm._self._c;return (false)?_c('div',{class:_vm.defaultCss + ' ' + _vm.position},[_c('el-button',{attrs:{"type":"text","size":"medium","icon":"el-icon-question"},on:{"click":function($event){return _vm.handleHelper()}}},[_vm._v("帮助中心")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }